import { useCallback, useEffect, useMemo, useState, type ReactNode } from 'react'
import { reopenWithNewAssets, watchForUpdate } from './detect'
import { AppUpdateContext } from './update-context'

/**
 * 새 자산이 준비됐다는 사실을 들고 있는 자리.
 *
 * 확인은 어느 화면에서나 조용히 돈다. 알림을 낼 수 있는 화면은 정해져 있으므로 결과를 여기서
 * 들고 있다가 그 화면이 설 때 꺼낸다. 작성 화면에서 확인이 끝나도 그 자리에서는 그리지 않고
 * 사용자가 홈과 타임라인에 설 때 보인다.
 *
 * 우리가 대신 누르지 않는다. 준비됐다는 것만 알고 있고 화면을 다시 세우는 일은 사용자가 버튼을
 * 누를 때만 일어난다.
 */
export function AppUpdateProvider({ children }: { children: ReactNode }) {
  const [ready, setReady] = useState(false)
  const [reopening, setReopening] = useState(false)

  useEffect(() => watchForUpdate(() => setReady(true)), [])

  const reopen = useCallback(() => {
    setReopening(true)
    reopenWithNewAssets()
  }, [])

  const value = useMemo(() => ({ ready, reopening, reopen }), [ready, reopening, reopen])

  return <AppUpdateContext value={value}>{children}</AppUpdateContext>
}
